<template>
  <div class="formula-criterion" :class="{ 'disabled-state': criterion.disabled }">
    <span v-if="index !== 0" class="formula-criterion-operator">OR</span>
    <div class="criterion-wrapper-top l-flex-row">
      <div class="formula-criterion-label flex-1" :title="criterion.label">
        {{ criterion.label }}
      </div>

      <div class="formula-criterion-volume l-flex-row flex-2" :class="{ 'l-flex-row': criterion.disabled }">
        <div class="formula-criterion-settings l-flex-row">
          <template v-if="criterion.hasFrequency && isNotSharedSegment">
            <div class="formula-criterion-setting is-double">
              <svg-icon class="formula-setting-icon" name="period" size="small" title="Frequency" />
              <PeriodAndFrequencySelect
                :criterion="criterion"
                @periodChange="criterion.setfrequencyPeriod($event)"
                @frequencyChange="criterion.setfrequencyRange($event)"
              />
            </div>
          </template>

          <template v-if="criterion.recency && criterion.recency.display">
            <div class="formula-criterion-setting" :title="recencyLabel">
              <svg-icon class="formula-setting-icon" name="calendar" size="small" />
              <WamSelect
                label="recency"
                icon="calendar"
                :disabled="criterion.recency.disabled || recencyDisabled"
                :options="criterion.recency.availableValues"
                :value="criterion.recency.value"
                @change="criterion.setRecency($event)"
              />
            </div>
          </template>

          <template v-if="criterion.isSocioDemo && criterion.quantile && box.formula.defaultQuantile.display">
            <div class="formula-criterion-setting" :title="'Quantile: ' + criterion.quantile.value">
              <svg-icon class="formula-setting-icon" name="quantile" size="small" title="Quantile" />
              <WamSelect
                label="quantile"
                icon="quantile"
                :options="criterion.quantile.availableValues"
                :value="criterion.quantile.value"
                @change="criterion.setQuantile($event)"
              />
            </div>
          </template>

          <template v-if="criterion.isSocioDemo && criterion.surfIntensity && box.formula.defaultSurfIntensity.display">
            <div class="formula-criterion-setting" :title="'Surf intensity: ' + criterion.surfIntensity.value">
              <svg-icon class="formula-setting-icon" name="target" size="small" title="Surf Intensity" />
              <WamSelect
                label="intensity"
                icon="target"
                :options="criterion.surfIntensity.availableValues"
                :value="criterion.surfIntensity.value"
                @change="criterion.setSurfIntensity($event)"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="criterion-tag formula-criterion-path" @click="selectPath(criterion.path)">
      {{ criterion.path.join(' / ') }}
    </div>
    <div class="criterion-wrapper-btm l-flex-row l-flex-row--rev">
      <CellVolume position="criteria" :parent="'builder'" :full-data="volume" type="volume" />
      <div class="formula-criterion-action action-hidden-menu">
        <svg-icon class="cursor" name="dots" size="small" />
        <div class="menu-action-hidden--right">
          <ul>
            <li class="dot-menu-item" :title="criterionDisablingLabel" @click="criterion.toggleDisable()">
              <label>{{ criterionDisablingLabel }}</label>
            </li>
            <li class="dot-menu-item" title="Remove criterion" @click="box.removeCriterion(index)">
              <label>Remove criterion</label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CellVolume from '@/components/monitoring/CellVolume'
import PeriodAndFrequencySelect from '@/components/builder/boxCriterionSelects/PeriodAndFrequencySelect.vue'
import WamSelect from '@/components/common/WamSelect/WamSelect'
import { mapMutations } from 'vuex'

export default {
    name: 'FormulaCriterion',

    components: {
        CellVolume,
        PeriodAndFrequencySelect,
        WamSelect
    },

    props: {
        box: {
            type: Object,
            required: true
        },
        criterion: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        volume: {
            type: Object,
            default: undefined
        }
    },

    computed: {
        criterionDisablingLabel() {
            return this.criterion.disabled ? 'Enable criterion' : 'Disable criterion'
        },

        recencyLabel() {
            const recency = this.criterion.recency.value
            if (recency === undefined) return 'Recency'
            const amountOfdays = recency !== 1 ? ' days' : ' day'
            return `Recency: ${recency} ${amountOfdays}`
        },

        recencyDisabled() {
            return !this.criterion?._frequencyPeriod?.value && this.isNotSharedSegment && this.criterion?.retention == 395
        },

        isNotSharedSegment() {
            return this.criterion.category !== 'SharedSegment'
        }
    },

    methods: {
        ...mapMutations('ui/builder', ['selectPath'])
    }
}
</script>


<style lang="scss">
.formula-criterion {
  position: relative;
  .formula-criterion-operator {
    position: absolute;
    top: -11px;
    left: 0;
    padding: 1px 8px;
    border: 1px solid var(--color-separator);
    border-radius: 4px;
    // background: rgba(250, 250, 250, 1);
    z-index: 9999;
    border-top-left-radius: unset;
    border-bottom-left-radius: unset;
    border-left: unset;
    background-color: var(--color-background-secondary);

  }
  .criterion-wrapper-btm {
    .volume-line {
      margin: unset;
      // max-width: 468px;
    }
  }
  .formula-criterion-volume {
    justify-content: flex-end;
    width: 100%;
    margin-right: 4em;
  }

}
</style>
